import { module } from "angular";

import type { Observable } from "rxjs";

import type { IHttpService } from "App/Modules/Services";

import type {
    IAlarmCentral,
    IEventQueueSlim,
    IOperatorSlim,
    IOperatorStationSlim,
    IResponse,
    ISiteSlim,
} from "App/Modules/Models";
import type { IAlarmCentralsRepository } from "./IAlarmCentralsRepository";

export default class AlarmCentralsRepository implements IAlarmCentralsRepository {
    public static $inject: string[] = ["mmHttpService"];

    constructor(private readonly httpService: IHttpService) {}

    public getAlarmCentrals(): Observable<IResponse<IAlarmCentral[]>> {
        return this.httpService.get<IAlarmCentral[]>("alarmCentrals");
    }

    public getAlarmCentral(alarmCentralId: string): Observable<IResponse<IAlarmCentral>> {
        return this.httpService.get<IAlarmCentral>(`alarmCentrals/${alarmCentralId}`);
    }

    public patchAlarmCentral(alarmCentralId: string, patchObject: IAlarmCentral): Observable<IResponse<IAlarmCentral>> {
        return this.httpService.patch<IAlarmCentral>(`alarmCentrals/${alarmCentralId}`, patchObject);
    }

    public addAlarmCentral(postObject: IAlarmCentral): Observable<IResponse<IAlarmCentral>> {
        return this.httpService.post<IAlarmCentral>("alarmCentrals", postObject);
    }

    public getEventQueues(alarmCentralId: string): Observable<IResponse<IEventQueueSlim[]>> {
        return this.httpService.get<IEventQueueSlim[]>(`alarmCentrals/${alarmCentralId}/eventQueues`);
    }

    public getOperators(alarmCentralId: string): Observable<IResponse<IOperatorSlim[]>> {
        return this.httpService.get<IOperatorSlim[]>(`alarmCentrals/${alarmCentralId}/operators`);
    }

    public getOperatorStationsForAlarmCentral(alarmCentralId: string): Observable<IResponse<IOperatorStationSlim[]>> {
        return this.httpService.get<IOperatorStationSlim[]>(`alarmCentrals/${alarmCentralId}/operatorStations`);
    }

    public getSites(alarmCentralId: string): Observable<IResponse<ISiteSlim[]>> {
        return this.httpService.get<ISiteSlim[]>(`alarmCentrals/${alarmCentralId}/sites`);
    }
}

module("mmRepositories").service("mmAlarmCentralsRepository", AlarmCentralsRepository);
